import {
  GET_INTERVENTIONS_LIST_IN_PROGRESS,
  GET_INTERVENTIONS_LIST_SUCCESS,
  GET_INTERVENTIONS_LIST_FAIL,
  GET_INTERVENTION_INFO_IN_PROGRESS,
  GET_INTERVENTION_INFO_SUCCESS,
  GET_INTERVENTION_INFO_FAIL,
  GET_INTERVENTIONS_LIST_FILTERS_IN_PROGRESS,
  GET_INTERVENTIONS_LIST_FILTERS_SUCCESS,
  GET_INTERVENTIONS_LIST_FILTERS_FAIL,
  GET_INTERVENTIONS_LIST_COUNT_IN_PROGRESS,
  GET_INTERVENTIONS_LIST_COUNT_SUCCESS,
  GET_INTERVENTIONS_LIST_COUNT_FAIL,
} from "../constants";
import { LOGOUT } from "../../authentication/constants";

const initialState = {
  list: [],
  inProgress: false,
  error: false,
  info: undefined,
  listCalled: false,
  filters: {},
  filtersInProgress: false,
  count: 0,
  countInProgress: false,
};

/**
 * Intervention reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function interventions(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_INTERVENTION_INFO_IN_PROGRESS:
      return {
        ...state,
        info: undefined,
      };

    case GET_INTERVENTION_INFO_SUCCESS:
      return {
        ...state,
        info: payload.info,
      };

    case GET_INTERVENTION_INFO_FAIL:
      return {
        ...state,
        info: null,
      };

    case GET_INTERVENTIONS_LIST_IN_PROGRESS:
      return {
        ...state,
        inProgress: true,
        error: false,
        listCalled: true,
      };

    case GET_INTERVENTIONS_LIST_SUCCESS:
      return {
        ...state,
        list: payload.list,
        inProgress: false,
      };

    case GET_INTERVENTIONS_LIST_FAIL:
      return {
        ...state,
        inProgress: false,
        error: true,
      };

    case GET_INTERVENTIONS_LIST_FILTERS_IN_PROGRESS:
      return {
        ...state,
        filtersInProgress: true,
        error: false,
      };

    case GET_INTERVENTIONS_LIST_FILTERS_SUCCESS: {
      return {
        ...state,
        filters: { ...state.filters, ...payload.filters },
        filtersInProgress: false,
      };
    }

    case GET_INTERVENTIONS_LIST_FILTERS_FAIL:
      return {
        ...state,
        filtersInProgress: false,
        error: true,
      };

    case GET_INTERVENTIONS_LIST_COUNT_IN_PROGRESS:
      return {
        ...state,
        countInProgress: true,
        error: false,
      };

    case GET_INTERVENTIONS_LIST_COUNT_SUCCESS:
      return {
        ...state,
        count: payload.count,
        countInProgress: false,
      };

    case GET_INTERVENTIONS_LIST_COUNT_FAIL:
      return {
        ...state,
        countInProgress: false,
        error: true,
      };

    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
}
